import { styles } from "./Styles";
const { colors } = styles;

export const Colors = {
  White: colors.White,
  White_a75: colors.White_a75,
  Black: colors.Black,
  Gray: colors.Gray,
  Green: colors.Green,
  Gray_a50: colors.Gray_a50,
  GrayL80: colors.GrayL80,
  GrayL95: colors.GrayL95,
  purple: colors.Purple,
  Main: colors.Main,
  MainText: colors.MainText,
  Focus: colors.Focus,
  Focus_a25: colors.Focus_a25,
  Blur: colors.Blur,
  Good: colors.Good,
  Warn: colors.Warn,
  Error: colors.Error,
  DialogBg: colors.DialogBg,

  // UI
  UILine: colors.UILine,
  CurrentTopbar: colors.CurrentTopbar,

  // Pressure
  Over_1: colors.Over_1,
  Over_5: colors.Over_5,
  Over_10: colors.Over_10,
  Over_30: colors.Over_30,
  Over_60: colors.Over_60,
  Over_90: colors.Over_90,
  Over_120: colors.Over_120,

  // Average Pressure
  Level_0: colors.Level_0,
  Level_1: colors.Level_1,
  Level_2: colors.Level_2,
  Level_3: colors.Level_3,
  Level_4: colors.Level_4,
  Level_5: colors.Level_5,

  // Event
  Event_Stirring: colors.Event_Stirring,
  Event_Sittingup: colors.Event_Sittingup,
  Event_OutofBed: colors.Event_OutofBed,
  Event_Reposition: colors.Event_Reposition,
  Event_Immobile: colors.Event_Immobile,
  Event_Reset: colors.Event_Reset,
  Event_NurseMode: colors.Event_NurseMode,
  Event_NurseMode_a50: colors.Event_NurseMode_a50,
  Act_high: colors.Act_high,
  Act_Low: colors.Act_Low,
  Act_null: colors.Act_null,

  // Alpha Colors
  Black_a4: colors.Black_a4,
  Black_a12: colors.Black_a12,
  White_a0: colors.White_a0,
  White_a50: colors.White_a50,

  Header: colors.Header,
  ContentBackground: colors.ContentBackground,
  SideBar: colors.SideBar,
  Border1: colors.Border1,
  BorderInner: colors.BorderInner,
  TimerBox: colors.TimerBox,

  // Patient detail
  Resting: colors.Resting,
  Moving: colors.Moving,
  OffBed: colors.OffBed,
  Unknown: colors.Unknown,
};
if (Object.freeze) Object.freeze(Colors);
